import * as React from 'react'
import * as classNames from 'classnames'
import { getBannerStyles, mixins } from '@sphinx/components-styles'
import NoSavedStoriesImageSrc from '../../assets/NoSavedStories.svg'

const NoSavedStoriesBanner = getBannerStyles({
  width: 168,
  height: 194,
  bannerImgSrc: NoSavedStoriesImageSrc,
})

interface NoSavedStoriesImageSrcProps
  extends React.HTMLAttributes<HTMLDivElement> {
  message: string
}

export const NoSavedStories: React.FC<NoSavedStoriesImageSrcProps> = ({
  children,
  className,
  message,
  ...props
}) => (
  <div className={classNames(NoSavedStoriesBanner, className)} {...props}>
    <p>{message}</p>
    {React.Children.toArray(children)}
  </div>
)
